import { render, staticRenderFns } from "./patientWarnMessageDialog.vue?vue&type=template&id=2e216a0e&scoped=true"
import script from "./patientWarnMessageDialog.vue?vue&type=script&lang=js"
export * from "./patientWarnMessageDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e216a0e",
  null
  
)

export default component.exports